import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	font-weight: 600;

	width: 100%;
	height: 100%;
`;

export const Content = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	padding-bottom: 30px;
	max-height: 70vh;
	overflow-y: auto;
`;

export const SpinnerContent = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50vh;
`;

export const Preview = styled.div`
	overflow-y: scroll;
	max-height: 100%;

	ul {
		padding: 30px;
		list-style: disc;
	}
`;
